export const affordabilityMock = {
  loanAmount: 1_500_000,
  loanToValue: 85,
};
